module.exports = __webpack_public_path__ + "img/area_normal@2x.827700b3.svg";